import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import { CustomGoogleLoginButtonContent } from "./CustomGoogleLoginButtonContent";

export const CustomGoogleLoginButton = () => (
  <GoogleOAuthProvider clientId={process.env.RAZZLE_APP_GOOGLE_CLIENT_ID || ""}>
    <CustomGoogleLoginButtonContent />
  </GoogleOAuthProvider>
);
